import { Documentupload, Trash } from "../../../assets";
import { Button, Input, Layout } from "../../components";
import { ProcessCompleteController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import { LinearProgress } from "@mui/material";

class ProcessComplete extends ProcessCompleteController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getLimitation();
  }
  renderFileUpload = (type: string, label: string) => {
    const filePreviews = Array.isArray(this.state.uploadedFiles[type])
      ? this.state.uploadedFiles[type]
      : [];

    return (
      <div className="uploader">
      <div className="img-container">
        {filePreviews.length > 0 ? (
          filePreviews.map((fileObj, index) => (
            <div className="content" key={index}>
              <img
                src={fileObj.preview}
                alt={`${label} ${index + 1}`}
                className="img"
              />

              {this.state.clicked || this.state.fileErrors.length === 0 &&
              <div className="remove">
                <img
                  src={Trash}
                  alt="Remove"
                  onClick={() => this.handleRemoveFile(type, index)}
                />
              </div>
  }
            </div>
          ))
        ) : (
          <div className="file-upload">
            <div className="file-upload-btn">
              <label htmlFor={`${type}-file-input`}>
                <img src={Documentupload} alt="Upload" />
              </label>
              <input
                type="file"
                accept="image/*"
                id={`${type}-file-input`}
                hidden
                onChange={(event) => {
                  const file = event.target.files?.[0];
                  if (file) this.handleFileUpload(file, type);
                }}
              />
            </div>
            <h5 className="file-upload-text">{label}</h5>
          </div>
        )}
      </div>
           <div className="error-text w-100 mr-2 ">
                  {this.state.fileErrors?.filter((name: { path: string; }) => name.path ===type)?.[0]?.errors?.[0]}
                </div>
                </div>
    );
  };



  render() {
    const { policyHolderOtp,insuredOtpTimer, policyHolderOtpTimer, insuredOtp, limitaionData , policyHolderErrors , insuredErrors , loading , policyHolderOtpLoading , insuredOtpLoading , policyHolderOtpDisabled , insuredOtpDisabled } = this.state;
    return (
      <Layout title="تکمیل فرآیند">
        <Helmet>
          <title>تکمیل فرآیند</title>
        </Helmet>
         {loading ?
                  <LinearProgress />
                  :
        <div className=" inquery process-complete scrollbar">
        <div className="inquery-container ">

          <div className="inquery-content process-complete-container">
        

        {/* File Upload Section */}
        <div className="card-container">
          <div className="card-container-headline">
            <span className="title">ارسال مدارک</span>
          </div>
          <div className="content">
            {limitaionData.find((item:any) => item.name === "insuredEqualPolicyHolder")?.default ? (
              this.renderFileUpload("policyHolderIdCard", "کارت ملی")
            ) : (
              <>
                {this.renderFileUpload("insuredIdCard", "کارت ملی بیمه‌شده")}
                {this.renderFileUpload("policyHolderIdCard", "کارت ملی بیمه‌گذار")}
              </>
            )}

            {limitaionData.find((item:any) => item.name === "relation_with_policy_holder")?.default && (
              this.renderFileUpload("guardianLetter", "نامه ولی")
            )}

            {!limitaionData.find((item:any) => item.name === "shahkar_results")?.default && (
              this.renderFileUpload("signedForm", "فرم امضاشده")
            )}
          </div>
        </div>
{!this.state.clicked || this.state.fileErrors.length > 0 ? null : <>
       
        {/* OTP Section */}
        <div className="card-container">
          <div className="card-container-headline flex-wrap">
            <span className="title mb-2"> تاییدیه اظهارات </span>
            <p className="description">	اینجانبان (بیمه‌گذار و بیمه‌شده) اعلام می‌نماییم که کلیه‌ مفاد فرم پیشنهاد، شرایط عمومی بیمه‌نامه را به عنوان شروط ضمن عقد، مطالعه نموده و به کلیه‌ سوالات با صداقت و دقت پاسخ داده و مطلع هستیم که هرگونه اظهارنظر خلاف واقع و یا خودداری از واقع‌گویی به عمد، به موجب ماده‌ 12 قانون بیمه باعث باطل‌شدن قرارداد بیمه‌ زندگی و از دست‌دادن مزایای آن خواهد شد. ضمنا با اطلاع کامل از حدود تعهدات خود و بیمه‌گر، تقاضای صدور بیمه‌نامه را دارم. همچنین بیمه‌گر یا پزشکان معتمد بیمه‌گر اجازه دارند هرگونه اطلاعات مورد نیاز که راجع به وضع مزاجی و سلامت بیمه‌شده باشد را کسب نمایند.</p>

          </div>
          <div className="content">

            {limitaionData.find((item:any) => item.name === "verify_policy_holder_phon_number")?.default ? (
            <div className="verified-badge-container">
  <div className="verified-badge">
    <svg
      className="verified-badge-icon"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"
        fill="#4CAF50"
      />
    </svg>
    <span className="verified-badge-text">تایید بیمه‌گذار</span>
  </div>
</div>
            ) : ( 
            <>
            {/* بیمه‌گذار */}
           <div className="otp-container">
           <div className="otp-item">
              <Input
                  value={policyHolderOtp}
                lable={`ارسال کد تایید به شماره  (بیمه گذار) : ${
                  limitaionData.find((item: any) => item.name === "policy_holder_phon_number")
                    ?.default || ""
                }`}
                hideEndAdornment
                type="number"
                disabled={policyHolderOtpDisabled}
                max="5"
                myStyle="otp-item-input w-100"
                error={policyHolderErrors?.filter((name: { path: string; }) => name.path === "policyHolderOtp")?.[0]?.errors?.[0] || " "}
                onChange={(e: any) => this.setState({ policyHolderOtp: e })}
                placeholder={policyHolderOtpDisabled ?  limitaionData.find((item: any) => item.name === "policy_holder_phon_number")
                  ?.default : " رمز ارسال شده به شماره موبایل فوق را وارد کنید "}              />
              <Button
                myStyle="otp-item-btn"
                loading={policyHolderOtpLoading}
                title={policyHolderOtpDisabled ? "ارسال کد" : `تایید کد ${policyHolderOtpTimer > 0 ? `(${policyHolderOtpTimer})` : ""}`}
                onClick={
                  policyHolderOtpDisabled
                  ? () => {
                        this.getOtp(limitaionData.find(item => item.name === "policy_holder_phon_number")?.default, true);
                        this.startOtpTimer(true);
                      }
                    : () => this.verifyPolicyHolderOtp(limitaionData.find(item => item.name === "policy_holder_phon_number")?.default)
                }
              />
            </div>
                <label className="custom-input-error hide-mobile">
                  {policyHolderErrors?.filter((name: { path: string; }) => name.path === "policyHolderOtp")?.[0]?.errors?.[0] || " "}
                </label>
           </div>
           </>
            )}
              {limitaionData.find((item:any) => item.name === "verify_insured_phon_number")?.default ? 
              <div className="verified-badge-container">
  <div className="verified-badge">
    <svg
      className="verified-badge-icon"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"
        fill="#4CAF50"
      />
    </svg>
    <span className="verified-badge-text">تایید بیمه شده</span>
  </div>
</div>
                : (  
                <>
            {/* بیمه‌شده */}
            {!limitaionData.find(
              (item: any) => item.name === "insuredEqualPolicyHolder"
            )?.default && (
           <div className="otp-container">

              <div className="otp-item">
                <Input
                    value={insuredOtp}
                  lable={`ارسال کد تایید به شماره (بیمه شده) : ${
                    limitaionData.find(
                      (item: any) => item.name === "insured_phon_number"
                    )?.default || ""
                  }`}
                  hideEndAdornment
                  disabled={insuredOtpDisabled}
                  max="5"
                  myStyle="otp-item-input w-100"
                  onChange={(e: any) =>
                    this.setState({ insuredOtp: e })
                  }
                  error={insuredErrors?.filter((name: { path: string; }) => name.path === "insuredOtp")?.[0]?.errors?.[0] || " "}
                  placeholder={insuredOtpDisabled ?  limitaionData.find((item: any) => item.name === "insured_phon_number")
                    ?.default : " رمز ارسال شده به شماره موبایل فوق را وارد کنید "}                              />

                <Button
                  myStyle="otp-item-btn"
                  loading={insuredOtpLoading}
                  title={insuredOtpDisabled ? "ارسال کد" : `تایید کد ${insuredOtpTimer > 0 ? `(${insuredOtpTimer})` : ""}`}
                  onClick={
                    insuredOtpDisabled
                      ? () => {
                          this.getOtp(limitaionData.find(item => item.name === "insured_phon_number")?.default, false);
                          this.startOtpTimer(false);
                        }
                      : () => this.verifyInsuredOtp(limitaionData.find(item => item.name === "insured_phon_number")?.default)
                  }
                />
              </div>
                <label className="custom-input-error hide-mobile">
                  {insuredErrors?.filter((name: { path: string; }) => name.path === "insuredOtp")?.[0]?.errors?.[0] || " "}
                </label>
              </div>
            )} 
            </>
 )} 
          </div>
        </div>
</> }

          <div className="inquery-btn-group">

          <Button
  myStyle="bg-blue next-btn"
  loading={this.state.draftOfferLoading}
  title={
    !this.state.clicked
      ? "ادامه"
      : this.state.fileErrors.length > 0
        ? "ادامه"
        : "ثبت نهایی"
  }
  onClick={async () => {
    if (!this.state.clicked) {
      const isValidFiles = await this.validateFilesOnly();
      if (isValidFiles) {
        this.setState({ clicked: true });
      }
    } else {
      const isValidOtp = await this.validateOtpsOnly();
      if (isValidOtp) {
        await this.universalDraftOffer();
      }
    }
  }}
/>
        </div>
                </div>
        </div>
        </div>
  }

      </Layout>
    );
  }
}

export default ProcessComplete;
